import { ModelBase } from 'store/model-base';

export class NowLineAutoPayCollection extends ModelBase {
    public static storeName: string = 'nowLineAutoPayCollection';

    public products: NowAutoPayProductsList[];

    public static create<T extends ModelBase>(initData: object): T {
        const toReturn: NowLineAutoPayCollection = super.create<NowLineAutoPayCollection>(initData);

        return super.create<T>(toReturn);
    }
}
